import React from 'react'
import { Bars } from 'react-loader-spinner'
import Loader from 'react-loader-spinner'

const Spinner = ({message}) => {
  return (

    <div className='flex flex-col justify-center items-center'>
        <Bars
        type="Circles"
        color="#00BFFF"
        height={50}
        width={50}
        className="m-5"
        />

        <p className='text-lg text-center px-2'>{message}</p>
    </div>
  )
}

export default Spinner